<template>
  <div class="pt-4 flex flex-col lg:flex-row p-4 min-h-screen bg-light-bg dark:bg-dark-bg dark:text-dark-text">

    <AppSidebar />

    <div class="flex flex-col flex-grow p-6 lg:p-12 space-y-4 h-full">
      <!-- Nagłówek strony -->
      <div class="flex flex-col sm:flex-row sm:justify-between items-start sm:items-center text-left space-y-2 sm:space-y-0">
        <h1 class="text-xl md:text-2xl font-bold pt-12 md:pt-0">Witaj w Panelu {{ welcomeHeader }}!</h1>
        <div class="text-sm font-medium sm:mr-4 lg:mr-32">
          <span>Witaj, {{ user.firstName }}!</span> | <span>{{ getRoleInPolish(user.role) }}</span>
        </div>
      </div>
 
      <!-- Główna siatka boxów -->
      <div class="grid grid-cols-1 gap-4 lg:grid-cols-4 w-full">
        <!-- Wykres z ilością zleceń per miesiąc -->
        <div class="lg:col-span-3 h-[22rem] sm:h-[26rem]">
          <div class="bg-white p-6 rounded-lg w-full h-full shadow-md border border-light-border dark:border-dark-border dark:bg-dark-box-bg dark:text-dark-text overflow-hidden">
            <div id="driversMap" class="w-full h-[calc(100%-2rem)]"></div>
          </div>
        </div>

        <!-- Statystyki - zawsze w dwóch kolumnach -->
        <div class="grid grid-cols-2 gap-2 lg:grid-cols-2 lg:gap-4 h-full">
          <div class="bg-white p-4 rounded-lg shadow-md border border-light-border text-light-text flex flex-col items-center justify-center h-full w-full dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text">
            <span class="text-xl font-bold">Do Obsługi:</span>
            <span class="text-3xl font-extrabold mt-1">{{ orders.TO_OPERATE || 0 }}</span>
          </div>
          <div class="bg-white p-4 rounded-lg shadow-md border border-light-border text-light-text flex flex-col items-center justify-center h-full w-full dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text">
            <span class="text-xl font-bold">Wysłane:</span>
            <span class="text-3xl font-extrabold mt-1">{{ orders.SEND || 0 }}</span>
          </div>
          <div class="bg-white p-4 rounded-lg shadow-md border border-light-border text-light-text flex flex-col items-center justify-center h-full w-full dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text">
            <span class="text-xl font-bold">W Trakcie:</span>
            <span class="text-3xl font-extrabold mt-1">{{ orders.IN_PROGRESS || 0 }}</span>
          </div>
          <div class="bg-white p-4 rounded-lg shadow-md border border-light-border text-light-text flex flex-col items-center justify-center h-full w-full dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text">
            <span class="text-xl font-bold">Przyjęte:</span>
            <span class="text-3xl font-extrabold mt-1">{{ orders.ACCEPT || 0 }}</span>
          </div>
        </div>
      </div>

      <!-- Sekcja dostępnych kierowców -->
      <div class="bg-white p-4 rounded-lg shadow-md border border-light-border w-full lg:col-span-2 h-auto dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text">
        <div class="flex items-center justify-between mb-4">
          <h2 class="text-lg font-semibold">{{ statusHeader }} kierowcy:</h2>
          <div class="flex items-center space-x-4">
            <label for="statusFilter" class="sr-only">Filtruj po statusie:</label>
            <select v-model="selectedStatus" id="statusFilter" class="block p-2 border border-light-border rounded-md bg-white text-light-text dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text">
              <option value="">Wszystkie</option>
              <option value="DOSTEPNY" class="text-green-500 dark:text-green-500">Dostępny</option>
              <option value="NIEDOSTEPNY" class="text-orange-500 dark:text-orange-500">Niedostępny</option>
              <option value="W_TRAKCIE" class="text-yellow-500 dark:text-yellow-500">W Trakcie</option>
              <option value="PRZYJETE" class="text-blue-500 dark:text-blue-500">Przyjęte</option>
            </select>
          </div>
        </div>
    <div class="w-full">
        <div v-if="paginatedDrivers.length === 0" class="text-center py-4 text-light-status-unavailable font-semibold dark:text-dark-status-unavailable">
            Brak dostępnych kierowców
        </div>
        <div v-else class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
            <div
                v-for="(driver) in paginatedDrivers"
                :key="driver.id"
                class="flex items-center justify-between p-2 border border-gray-300 dark:border-dark-border rounded-lg bg-light-bg dark:bg-dark-table-bg hover:bg-light-hover dark:hover:bg-dark-hover transition-colors"
            >
                <div class="flex items-center space-x-2 text-xs lg:text-sm text-light-text dark:text-dark-text truncate flex-1">
                    <div class="w-6 h-6 bg-light-icon-bg rounded-full flex items-center justify-center dark:bg-teal-200">
                        <span class="text-xs font-bold text-light-icon-text dark:text-teal-800">
                            {{ driver.firstName.charAt(0) }}{{ driver.lastName.charAt(0) }}
                        </span>
                    </div>
                    <span>{{ driver.firstName }} {{ driver.lastName }}</span>
                </div>

                <div class="py-2 px-2 text-xs lg:text-sm text-light-text dark:text-dark-text flex-shrink-0">
                    <span
                        v-if="driver.driverStatus === 'DOSTEPNY'"
                        class="inline-flex items-center bg-green-500 hover:bg-green-600 text-white text-xs font-medium px-2 py-1 rounded-full truncate"
                    >
                        DOSTĘPNY
                    </span>
                    <span
                        v-else-if="driver.driverStatus === 'NIEDOSTEPNY'"
                        class="inline-flex items-center bg-orange-500 hover:bg-orange-600 text-white text-xs font-medium px-2 py-1 rounded-full truncate"
                    >
                        NIEDOSTĘPNY
                    </span>
                    <span
                        v-else-if="driver.driverStatus === 'W_TRAKCIE'"
                        class="inline-flex items-center bg-yellow-500 hover:bg-yellow-600 text-white text-xs font-medium px-2 py-1 rounded-full truncate"
                    >
                        W TRAKCIE
                    </span>
                    <span
                        v-else-if="driver.driverStatus === 'PRZYJETE'"
                        class="inline-flex items-center bg-blue-500 hover:bg-blue-600 text-white text-xs font-medium px-2 py-1 rounded-full truncate"
                    >
                        PRZYJĘTE
                    </span>
                </div>

                <div class="flex-shrink-0 ml-2">
                    <button @click="goToProfile(driver)" class="text-gray-500 hover:text-gray-700 dark:text-dark-text p-1 rounded-full hover:bg-gray-200 dark:hover:bg-dark-hover transition-colors">
                        <UserIcon class="w-5 h-5" />
                    </button>
                </div>
            </div>
        </div>
    </div>

        <!-- Paginacja -->
        <div class="mt-4 flex flex-col sm:flex-row items-center justify-between space-y-4 sm:space-y-0">
          <div class="text-center sm:text-left text-sm text-light-text dark:text-gray-400">
            Wyświetlono {{ (currentPage - 1) * itemsPerPage + paginatedDrivers.length }} z {{ filteredDrivers.length }} kierowców
          </div>

          <div class="flex flex-wrap justify-center sm:justify-end items-center gap-2">
            <button v-if="currentPage > 1"
                    @click="goToPage(1)"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              Pierwsza strona
            </button>
            <button v-if="currentPage > 1"
                    @click="prevPage"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              &laquo; Poprzednia
            </button>
            <button v-for="page in visiblePages"
                    :key="page"
                    @click="goToPage(page)"
                    :class="[currentPage === page ? 'bg-teal-700 text-white' : 'bg-gray-200 dark:bg-dark-box-bg text-gray-700 dark:text-dark-text']"
                    class="px-3 py-1 text-sm font-medium rounded-md transition-colors hover:bg-teal-700 hover:text-white dark:hover:bg-teal-600 dark:hover:text-white">
              {{ page }}
            </button>
            <button v-if="currentPage < totalPages"
                    @click="nextPage"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              Następna &raquo;
            </button>
            <button v-if="currentPage < totalPages"
                    @click="goToPage(totalPages)"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              Ostatnia strona
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/authStore';
import { useSessionStore } from '@/stores/useSessionStore';
import dashboardService from '@/services/dashboardService';
import driverLocationService from '@/services/driverLocationService';
import AppSidebar from '@/components/AppSidebar.vue';
import { Chart, registerables } from 'chart.js';
import {UserIcon} from '@heroicons/vue/24/solid';
import { RoleMap } from '../utils/roleMap';
import L from 'leaflet';

Chart.register(...registerables);

export default {
  name: 'DashboardPageDispatcher',
  components: {UserIcon, AppSidebar},
  setup() {
    const authStore = useAuthStore();
    const sessionStore = useSessionStore();
    if (authStore.isAuthenticated) {
        authStore.checkExpiration();
    }
    return { user: authStore.user, sessionStore };
  },
  data() {
    return {
      orders: [],
      ordersByMonth: [],
      drivers: [],
      currentDateTime: '',
      ordersChart: null,
      selectedStatus: '',
      currentPage: 1,
      itemsPerPage: 9,
      visiblePages: [],

      NEW: 0,
      IN_PROGRESS: 0,
      PENDING: 0,

      isDesktop: window.innerWidth >= 1024, // sprawdzamy szerokość ekranu przy starcie
    };
  },
  watch: {
    selectedStatus() {
        this.currentPage = 1;
        this.updateVisiblePages();
    }
  },
  computed: {
    welcomeHeader() {
      switch (this.user.role) {
        case 'ROLE_ADMIN':
          return 'Administratora';
        case 'ROLE_YOUNG_DISPATCHER':
        case 'ROLE_ADULT_DISPATCHER':
          return 'Dyspozytora';
        case 'ROLE_DRIVER':
          return 'Kierowcy';
        default:
          return 'Użytkownika'; // Domyślny tekst, gdy rola nie jest zdefiniowana
      }
    },
    filteredDrivers() {
      // Tworzymy kopię tablicy, aby nie modyfikować oryginalnej
      let drivers = [...this.drivers];

      // Sortujemy listę kierowców
      drivers.sort((a, b) => {
        // Warunek sortowania: jeśli wybrano "Wszyscy", sortujemy najpierw po statusie
        if (this.selectedStatus === '') {
          const statusOrder = { 'DOSTEPNY': 1, 'PRZYJETE': 2, 'W_TRAKCIE': 3, 'NIEDOSTEPNY': 4 };
          const statusA = statusOrder[a.driverStatus] || 99;
          const statusB = statusOrder[b.driverStatus] || 99;
          
          if (statusA !== statusB) {
            return statusA - statusB;
          }
        }
        
        // Drugorzędne sortowanie: alfabetycznie po imieniu
        if (a.firstName < b.firstName) return -1;
        if (a.firstName > b.firstName) return 1;
        return 0;
      });

      // Następnie filtrujemy posortowaną listę, jeśli wybrano konkretny status
      if (this.selectedStatus !== '') {
        drivers = drivers.filter(driver => driver.driverStatus === this.selectedStatus);
      }
      
      return drivers;
    },
    paginatedDrivers() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredDrivers.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredDrivers.length / this.itemsPerPage);
    },
    availableDrivers() {
      return this.drivers.filter(driver => driver.driverStatus === 'DOSTEPNY').length;
    },
    statusHeader() {
      switch (this.selectedStatus) {
        case 'DOSTEPNY':
          return 'Dostępni';
        case 'NIEDOSTEPNY':
          return 'Niedostępni';
        case 'W_TRAKCIE':
          return 'W Trakcie';
        case 'ZAKONCZONY':
          return 'Zakończeni';
        case 'PRZYJETE':
          return 'Przyjęci';
        default:
          return 'Wszyscy';
      }
    },
  },
  async mounted() {
    await this.fetchOrders();
    await this.fetchDrivers();
    await this.fetchOrdersByMonth();
    this.updateDateTime();
    this.initializeMap();
    this.sessionStore.startInterval(this.updateDateTime, 60000);
    this.sessionStore.startInterval(this.fetchDrivers, 10000);

    // Dodanie listenera do trybu (dark/light) oraz do zmian rozmiaru ekranu
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    darkModeMediaQuery.addEventListener('change', this.updateChartColors);
  },
  beforeUnmount() {
    this.sessionStore.stopInterval();
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    darkModeMediaQuery.removeEventListener('change', this.updateChartColors);
  },
  methods: {
    async fetchOrders() {
      try {
        const response = await dashboardService.getOrdersByStatus();
        this.orders = response.data;
      } catch (error) {
        console.error('Error fetching orders:', error);
      }
    },
    async fetchOrdersByMonth() {
      try {
        const response = await dashboardService.getOrdersByMonth();
        this.ordersByMonth = response.data;
      } catch (error) {
        console.error('Error fetching orders:', error);
      }
    },
    async fetchDrivers() {
      try {
        const [driversResponse, locationsResponse] = await Promise.all([
          dashboardService.getAvailableDrivers(),
          driverLocationService.getLatestLocationsForAvailableDrivers()
        ]);
        const locations = Array.isArray(locationsResponse.data)
          ? locationsResponse.data
          : locationsResponse.data
            ? [locationsResponse.data]
            : [];
        this.drivers = driversResponse.data.map(driver => {
          const location = locations.find(loc => loc.driverId === driver.id);
          return { ...driver, lastLocation: location || null };
        });
        this.errorMessage = null;
        this.updateVisiblePages();
        this.updateMapMarkers();
      } catch (error) {
        console.error('Error fetching drivers or locations:', error);
        this.errorMessage = 'Nie udało się pobrać listy kierowców lub ich lokalizacji';
      }
    },
    updateDateTime() {
      const now = new Date();
      const day = now.getDate().toString().padStart(2, '0');
      const month = (now.getMonth() + 1).toString().padStart(2, '0');
      const year = now.getFullYear();
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      this.currentDateTime = `${day}.${month}.${year} ${hours}:${minutes}`;
    },
    getRoleInPolish(role) {
      return RoleMap[role] || 'Nieznana rola';
    },
    getAxisColor() {
      return document.documentElement.classList.contains('dark') ? '#FFFFFF' : '#000000';
    },
    goToProfile(driver) {
      if (this.user.role === 'ROLE_ADMIN') {
        this.$router.push({
          name: 'DriverProfileAdmin', 
          params: {id: driver.id},
          query: { returnTo: this.$route.name }
        });
      } else {
        this.$router.push({name: 'DriverProfileDispatcher', params: {id: driver.id}});
      }
    },
    goToPage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
        this.updateVisiblePages();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.updateVisiblePages();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.updateVisiblePages();
      }
    },
    updateVisiblePages() {
      const range = 5; // Liczba stron do wyświetlenia
      const start = Math.max(1, this.currentPage - Math.floor(range / 2));
      const end = Math.min(start + range - 1, this.totalPages);

      this.visiblePages = Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
    initializeMap() {
        const mapDiv = document.getElementById('driversMap');
        if (!mapDiv) {
          console.error('Map element not found');
          return;
        }

        // Inicjalizacja mapy
        this.map = L.map(mapDiv).setView([52.2297, 21.0122], 6); // Domyślne centrum: Warszawa, Polska
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
          maxZoom: 18,
        }).addTo(this.map);

        this.driverIcons = {
          PRZYJETE: L.icon({
            iconUrl: '/images/car_blue.png',
            iconSize: [32, 32],
            iconAnchor: [16, 16],
            popupAnchor: [0, -16],
          }),
          DOSTEPNY: L.icon({
            iconUrl: '/images/car_green.png',
            iconSize: [32, 32],
            iconAnchor: [16, 16],
            popupAnchor: [0, -16],
          }),
          W_TRAKCIE: L.icon({
            iconUrl: '/images/car_yellow.png',
            iconSize: [32, 32],
            iconAnchor: [16, 16],
            popupAnchor: [0, -16],
          }),
        };

        this.defaultIcon = L.icon({
          iconUrl: '/images/car_blue.png',
          iconSize: [32, 32],
          iconAnchor: [16, 16],
          popupAnchor: [0, -16],
        });

        // Inicjalizacja markerów
        this.markers = [];
        this.isMapInitialized = false;
        this.updateMapMarkers();
    },
    updateMapMarkers() {
        if (!this.map) return;

        // Usuń istniejące markery
        this.markers.forEach(marker => marker.remove());
        this.markers = [];

        // Filtruj kierowców z lokalizacjami
        const driversWithLocations = this.filteredDrivers.filter(
          driver => driver.lastLocation && driver.lastLocation.latitude && driver.lastLocation.longitude
        );

        // Dodaj nowe markery
        driversWithLocations.forEach(driver => {
          const icon = this.driverIcons[driver.driverStatus] || this.defaultIcon;
      
          const marker = L.marker([driver.lastLocation.latitude, driver.lastLocation.longitude], { icon })
            .addTo(this.map)
            .bindPopup(`${driver.firstName} ${driver.lastName}<br>Status: ${driver.driverStatus}`);
          // const marker = L.marker([driver.lastLocation.latitude, driver.lastLocation.longitude], { icon: driverIcon })
          //   .addTo(this.map)
          //   .bindPopup(`${driver.firstName} ${driver.lastName}<br>Status: ${driver.driverStatus}`);
          this.markers.push(marker);
        });

        // Dopasuj widok mapy do markerów, jeśli są
        if (driversWithLocations.length > 0 && !this.isMapInitialized) {
          const group = new L.featureGroup(this.markers);
          this.map.fitBounds(group.getBounds(), { padding: [50, 50], maxZoom: 15 }); // Dodano maxZoom
          this.isMapInitialized = true; // Ustaw flagę
        }
    },
  }
};
</script>

<style>
@media (max-width: 768px) {
  table {
    font-size: 12px;
  }
  th, td {
    padding: 4px;
  }
  .truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
#driversMap {
  width: 100%;
  height: 100%;
  z-index: 0;
}
</style>